<template>
  <footer>
    <section>
      <div v-if="contentMenuLinks.column1MenuLinks.length > 0">
        <div class="icons" >
          <h1>{{contentMenuLinks.column1MenuLinks[0].fields.header}}</h1>
          <ul>
            <li v-for="link in socialIcons" :key="link.url" class="list-item">
              <a :href="link.url"
                 class="icon flex justify-center items-center p-[5px] rounded-full hover:border hover:border-black w-[3.125rem] "
              >
                <component :is="link.icon" class=" inline-block align-baseline" />
              </a>
            </li>
          </ul>
        </div>
        <div v-if="contentMenuLinks['column1MenuLinks'][1]">
          <h1>{{contentMenuLinks.column1MenuLinks[1].fields.header}}</h1>
          <ul>
            <li v-for="item in contentMenuLinks['column1MenuLinks'][1]['fields']['cta']">
              <a :href="item['fields']['cta_url']">
                {{item['fields']['button']}}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="contentMenuLinks.column2MenuLinks">
        <h1>{{contentMenuLinks.column2MenuLinks.fields.header}}</h1>
        <ul>
          <li v-for="item in contentMenuLinks['column2MenuLinks']['fields']['cta']">
            <a :href="item['fields']['cta_url']">
              {{item['fields']['button']}}
            </a>
          </li>
        </ul>
      </div>
      <div v-if="contentMenuLinks.column3MenuLinks">
        <h1>{{contentMenuLinks.column3MenuLinks.fields.header}}</h1>
        <ul>
          <li v-for="item in contentMenuLinks.column3MenuLinks.fields.cta">
            <a :href="item['fields']['cta_url']">
              {{item['fields']['button']}}
            </a>
          </li>
        </ul>
      </div>
      <div v-if="contentMenuLinks.column4Subscribe" class="mail">
        <p>{{contentMenuLinks.column4Subscribe.fields.header}}</p>
        <form method="post" action="https://chloe.insightly.services/Forms/MTA3MzgwOC05MzYyLTE4ODU1MDI%3d">
          <input type="text" id="email" name="email" :placeholder="contentMenuLinks['column4Subscribe']['fields']['subscribeEMailField']" />
          <button type="submit" value="Submit" class="newsletter-sub-btn">
            {{contentMenuLinks['column4Subscribe']['fields']['cta'][0]['fields']['button']}}
          </button>
        </form>
      </div>
    </section>
    <div class="flex justify-center">
      <img :src="logo" alt="Hurst Logo" />
    </div>
    <p>{{bottomFooterText}}</p>
  </footer>
</template>

<script>
import {createClient} from "contentful";
import IconFacebook from "./Icons/IconFacebook";
import IconYoutube from "./Icons/IconYoutube";
import IconInstagram from "./Icons/IconInstagram";
import IconTwitter from "./Icons/IconTwitter";

let itemsFooter = {"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"2ToCpWnq8uUsM1woeHFDgh","type":"Entry","createdAt":"2022-08-18T16:10:59.090Z","updatedAt":"2022-08-26T13:51:37.139Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":4,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"footerAndElements"}},"locale":"en-US"},"fields":{"footerName":"Footer","column1MenuLinks":[{"sys":{"type":"Link","linkType":"Entry","id":"2N1zfL2eaG3gl24y3zB4cn"}},{"sys":{"type":"Link","linkType":"Entry","id":"3TvYpa2W7oMMUxEbd2orjb"}}],"column2MenuLinks":{"sys":{"type":"Link","linkType":"Entry","id":"6h5aTUzalmtwEFESpEfffw"}},"column3MenuLinks":{"sys":{"type":"Link","linkType":"Entry","id":"3hPhtV8UWG2WGG9UUyCfAn"}},"column4Subscribe":{"sys":{"type":"Link","linkType":"Entry","id":"k3kfD2s4XwGbuS6il3vah"}},"siteLogo":{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3QXnntkRHWMk6Bf576CbQ1","type":"Asset","createdAt":"2022-08-24T20:33:05.403Z","updatedAt":"2022-08-24T20:33:05.403Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":1,"locale":"en-US"},"fields":{"title":"Footer logo","description":"Logo for the Footer component","file":{"url":"//images.ctfassets.net/hk94475o187a/3QXnntkRHWMk6Bf576CbQ1/f775529d8b2bcc6361446d8b1aad75fc/Hurst-Logo-Orange.6963d3b7e87db91dd062.png","details":{"size":25222,"image":{"width":294,"height":287}},"fileName":"Hurst-Logo-Orange.6963d3b7e87db91dd062.png","contentType":"image/png"}}},"bottomFooterText":"HURST REVIEW HEADQUARTERS | 127 South Railroad Ave. Brookhaven, MS 39601 | Copyright @2022 Hurst Review"}}
let arrColumn1 = []
let arrColumn2 = []
let arrColumn3 = []
let arrColumn4 = []

let columnMenuLinks = {}


arrColumn1.push({"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"2N1zfL2eaG3gl24y3zB4cn","type":"Entry","createdAt":"2022-08-18T16:03:34.043Z","updatedAt":"2022-08-24T21:40:41.502Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":2,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"columnMenuLinks"}},"locale":"en-US"},"fields":{"columnMenuLinksName":"Column Menu Links 1 Stay Updated","header":"Stay Updated","cta":[{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"2jhuzEvRpvMgPcoWGlrXaC","type":"Entry","createdAt":"2022-08-18T16:02:29.137Z","updatedAt":"2022-09-15T19:40:55.836Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Facebook Footer CTA","button":"Facebook","cta_url":"https://www.facebook.com/hurstreview/"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"LtydzCUl8iZdnS26mWpBA","type":"Entry","createdAt":"2022-08-18T16:02:48.997Z","updatedAt":"2022-09-15T19:41:26.884Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":4,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Instagram Footer CTA","button":"Instagram","cta_url":"https://www.instagram.com/hurstreview/"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"5QANU9KcbU29zY1bslU6KZ","type":"Entry","createdAt":"2022-08-18T16:03:07.928Z","updatedAt":"2022-09-15T19:42:03.980Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Youtube Footer CTA","button":"Youtube","cta_url":"https://www.youtube.com/c/hurstreview"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3xQpqkHdkKKbke7hSp8Jqz","type":"Entry","createdAt":"2022-08-18T16:03:25.328Z","updatedAt":"2022-09-15T19:42:20.747Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Twitter Footer CTA","button":"Twitter","cta_url":"https://twitter.com/HurstReview"}}]}})
arrColumn1.push({"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3TvYpa2W7oMMUxEbd2orjb","type":"Entry","createdAt":"2022-08-18T16:04:31.965Z","updatedAt":"2022-08-18T16:04:31.965Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":1,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"columnMenuLinks"}},"locale":"en-US"},"fields":{"columnMenuLinksName":"Column Menu Links 1 Resources","header":"Resources","cta":[{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3rQl5Tg69lFQOM9a2rtyaV","type":"Entry","createdAt":"2022-08-18T16:04:10.713Z","updatedAt":"2022-09-15T19:39:22.742Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"FAQs Footer CTA","button":"FAQs","cta_url":"/resources/faq"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"29N3YYeIZVmHtLRO2mMdmm","type":"Entry","createdAt":"2022-08-18T16:04:26.577Z","updatedAt":"2022-09-15T19:39:36.829Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Blog Footer CTA","button":"Blog","cta_url":"/community/blog"}}]}})


arrColumn1 = [{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"2N1zfL2eaG3gl24y3zB4cn","type":"Entry","createdAt":"2022-08-18T16:03:34.043Z","updatedAt":"2022-08-24T21:40:41.502Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":2,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"columnMenuLinks"}},"locale":"en-US"},"fields":{"columnMenuLinksName":"Column Menu Links 1 Stay Updated","header":"Stay Updated","cta":[{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"2jhuzEvRpvMgPcoWGlrXaC","type":"Entry","createdAt":"2022-08-18T16:02:29.137Z","updatedAt":"2022-09-15T19:40:55.836Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Facebook Footer CTA","button":"Facebook","cta_url":"https://www.facebook.com/hurstreview/"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"LtydzCUl8iZdnS26mWpBA","type":"Entry","createdAt":"2022-08-18T16:02:48.997Z","updatedAt":"2022-09-15T19:41:26.884Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":4,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Instagram Footer CTA","button":"Instagram","cta_url":"https://www.instagram.com/hurstreview/"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"5QANU9KcbU29zY1bslU6KZ","type":"Entry","createdAt":"2022-08-18T16:03:07.928Z","updatedAt":"2022-09-15T19:42:03.980Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Youtube Footer CTA","button":"Youtube","cta_url":"https://www.youtube.com/c/hurstreview"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3xQpqkHdkKKbke7hSp8Jqz","type":"Entry","createdAt":"2022-08-18T16:03:25.328Z","updatedAt":"2022-09-15T19:42:20.747Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Twitter Footer CTA","button":"Twitter","cta_url":"https://twitter.com/HurstReview"}}]}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3TvYpa2W7oMMUxEbd2orjb","type":"Entry","createdAt":"2022-08-18T16:04:31.965Z","updatedAt":"2022-08-18T16:04:31.965Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":1,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"columnMenuLinks"}},"locale":"en-US"},"fields":{"columnMenuLinksName":"Column Menu Links 1 Resources","header":"Resources","cta":[{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3rQl5Tg69lFQOM9a2rtyaV","type":"Entry","createdAt":"2022-08-18T16:04:10.713Z","updatedAt":"2022-09-15T19:39:22.742Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"FAQs Footer CTA","button":"FAQs","cta_url":"/resources/faq"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"29N3YYeIZVmHtLRO2mMdmm","type":"Entry","createdAt":"2022-08-18T16:04:26.577Z","updatedAt":"2022-09-15T19:39:36.829Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Blog Footer CTA","button":"Blog","cta_url":"/community/blog"}}]}}]
arrColumn2 = {"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"6h5aTUzalmtwEFESpEfffw","type":"Entry","createdAt":"2022-08-18T16:07:30.217Z","updatedAt":"2022-08-24T22:30:53.070Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"columnMenuLinks"}},"locale":"en-US"},"fields":{"columnMenuLinksName":"Company Column Menu Links 2","header":"Company","cta":[{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3wL682BrlvJgbwOaW6wtA8","type":"Entry","createdAt":"2022-08-18T16:06:29.677Z","updatedAt":"2022-08-24T22:35:21.599Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":2,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Contact Footer CTA","button":"Contact","cta_url":"/contact"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"79EtmXJa6s6XF103fX6jrj","type":"Entry","createdAt":"2022-08-18T16:06:45.243Z","updatedAt":"2022-08-24T22:35:36.089Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":2,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Careers Footer CTA","button":"Careers","cta_url":"/careers"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"iVYRwdrM1m32Bu2LT7fn6","type":"Entry","createdAt":"2022-08-18T16:06:58.063Z","updatedAt":"2022-09-15T21:40:18.538Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Privacy Footer CTA","button":"Privacy","cta_url":"/privacy-policy"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"59RzjmAjK7BlVwkfsQSAL9","type":"Entry","createdAt":"2022-08-18T16:07:11.586Z","updatedAt":"2022-09-15T19:37:39.927Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Guarantee Footer CTA","button":"Guarantee","cta_url":"/about/guarantee"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"66kKWMCGQBcZmjAjzBEj7Z","type":"Entry","createdAt":"2022-08-18T16:07:24.644Z","updatedAt":"2022-08-24T22:36:22.745Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":2,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Terms Footer CTA","button":"Terms","cta_url":"/terms"}}]}}
arrColumn3 = {"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3hPhtV8UWG2WGG9UUyCfAn","type":"Entry","createdAt":"2022-08-18T16:08:35.550Z","updatedAt":"2022-08-24T22:31:16.159Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":4,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"columnMenuLinks"}},"locale":"en-US"},"fields":{"columnMenuLinksName":"Support Column Menu Links 3","header":"Support","cta":[{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"5eR8KUvFHgAioMLK0a3pnE","type":"Entry","createdAt":"2022-08-18T16:08:15.928Z","updatedAt":"2022-09-15T21:41:28.444Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"System Requirements Footer CTA","button":"System Requirements","cta_url":"https://hurstreview.zendesk.com/hc/en-us/articles/115003337846-Minimum-System-Requirements"}},{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"7s8g1LcrxfwkkPangc45qV","type":"Entry","createdAt":"2022-08-18T16:08:28.856Z","updatedAt":"2022-09-15T21:41:43.282Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Support Footer CTA","button":"Support","cta_url":"https://support.hurstreview.com"}}]}}
arrColumn4 = {"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"k3kfD2s4XwGbuS6il3vah","type":"Entry","createdAt":"2022-08-18T16:09:50.230Z","updatedAt":"2022-09-15T19:45:01.484Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":5,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"columnSubscribe"}},"locale":"en-US"},"fields":{"columnSubscribeName":"Subscribe Column Menu Links 4","header":"Join our mailing list to never miss an update from Hurst Review.","subscribeEMailField":"example@company.com","cta":[{"metadata":{"tags":[]},"sys":{"space":{"sys":{"type":"Link","linkType":"Space","id":"hk94475o187a"}},"id":"3HgUbVVZtHkqluTESP9FhD","type":"Entry","createdAt":"2022-08-18T16:09:30.308Z","updatedAt":"2022-09-15T21:44:02.046Z","environment":{"sys":{"id":"master","type":"Link","linkType":"Environment"}},"revision":3,"contentType":{"sys":{"type":"Link","linkType":"ContentType","id":"cta"}},"locale":"en-US"},"fields":{"ctaName":"Subscribe Footer CTA","button":"SUBSCRIBE","cta_url":"subscribe@hurstreview.com"}}]}}

columnMenuLinks = {
  column1MenuLinks: arrColumn1,
  column2MenuLinks: arrColumn2,
  column3MenuLinks: arrColumn3,
  column4Subscribe: arrColumn4,
}

let socialIcons = [
  {'icon': IconFacebook, 'url': columnMenuLinks['column1MenuLinks'][0]['fields']['cta'][0]['fields']['cta_url']},
  {'icon': IconInstagram, 'url': columnMenuLinks['column1MenuLinks'][0]['fields']['cta'][1]['fields']['cta_url']},
  {'icon': IconYoutube, 'url': columnMenuLinks['column1MenuLinks'][0]['fields']['cta'][2]['fields']['cta_url']},
  {'icon': IconTwitter, 'url': columnMenuLinks['column1MenuLinks'][0]['fields']['cta'][3]['fields']['cta_url']},
]

export default {
  name: "Footer",
  components: {IconTwitter, IconInstagram, IconYoutube, IconFacebook},
  props: {
    accessKey: String,
    spaceId: String,
    pageId: String
  },

  data() {
    return {
      logo: `https:${itemsFooter['fields']['siteLogo']['fields']['file']['url']}`,
      bottomFooterText: itemsFooter['fields']['bottomFooterText'],
      contentMenuLinks: columnMenuLinks,
      socialIcons: socialIcons
    };
  },

  async created() {
    // const contentfulClient =  createClient({
    //   space: this.spaceId,
    //   accessToken: this.accessKey
    // });
    //
    // const rootData = await contentfulClient.getEntry(this.pageId)
    // const itemsFooter = rootData.fields.footer;
    // const footerContent = await contentfulClient.getEntry(itemsFooter.sys.id);
    // this.logo = itemsFooter.fields.siteLogo.fields.file.url;
    // this.bottomFooterText = itemsFooter.fields.bottomFooterText;
    //
    // contentfulClient.getEntry(footerContent.fields.column2MenuLinks.sys.id).then(data => {
    //   this.contentMenuLinks['column2MenuLinks'] = data;
    // })
    // contentfulClient.getEntry(footerContent.fields.column3MenuLinks.sys.id).then(data => {
    //   this.contentMenuLinks['column3MenuLinks'] = data;
    // });
    // contentfulClient.getEntry(footerContent.fields.column4Subscribe.sys.id).then(data => {
    //   this.contentMenuLinks['column4Subscribe'] = data;
    // })
    //
    // for (const item of footerContent.fields.column1MenuLinks) {
    //   const data = await contentfulClient.getEntry(item.sys.id)
    //   this.contentMenuLinks.column1MenuLinks.push(data);
    // }
  }
}
</script>

<style scoped lang="postcss">
.icon {
  box-shadow: 0px 5px 20px -3px rgb(0 0 0 / 30%);
}
footer {
  margin: 0 auto;
  padding: 60px 2rem 0;
  text-align: center;


  section {
    text-align: center;

    @media screen and (min-width: 1200px) {
      display: flex;
      justify-content: space-between;
      text-align: left;
    }

    a {
      text-decoration: none;
      color: #707070;
      font-size: 30px;
      font-family: Montserrat;
      font-weight: normal;
    }

    div {
      h1 {
        font-weight: 600;
        font-size: 30px;
        margin-bottom: .5rem;
        color: theme(colors.brand.black.500);
      }

      .icons {


        ul {
          display: flex;
          margin-top: 1rem;
          place-content: center;
          justify-content: center;

          .list-item {
            margin: 0.5rem;

            a {
              display: flex;
              padding: 5px;
              font-size: 1.7rem;
              border-radius: 50%;
              border: 1px solid transparent;
              box-shadow: 0px 5px 20px -3px rgba(0, 0, 0, 0.3);
              transition: .3s;
              color: #707070;
              height: 50px;
              width: 50px;

              &:hover,
              &:active,
              &:focus {
                cursor: pointer;
                box-shadow: none;
                border-color: theme(colors.brand.black.500);
              }

            }
          }

          li:last-child {
            margin-right: 0;
          }
        }
      }

      div,
      p {
        font-weight: 300;
        font-size: 20px;
        font-family: Montserrat;
        margin-bottom: 1rem;
        list-style-type: none;
        color: theme(colors.brand.black.500);

        .list-item {
          margin-bottom: .5rem;

          &:hover,
          &:active,
          &:focus {
            a {
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
      }

      &.mail {
        max-width: 100%;
        text-align: left;
        padding: 2rem 0;

        @media screen and (min-width: 1200px) {
          max-width: 30%;
          padding: 0;
        }

        form {
          display: flex;
          flex-direction: column;

          input {
            border: 0;
            padding: 1rem;
            margin-bottom: 1rem;
            border-radius: 20px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
          }

          button {
            border: 0;
            font-weight: 300;
            padding: .6rem;
            font-size: 1.2rem;
            border-radius: 15px;
            text-transform: uppercase;
            border: 1px solid transparent;
            color: theme(colors.brand.black.500);
            box-shadow: 0px 5px 20px -3px rgba(0, 0, 0, 0.3);
            background-color: theme(colors.white);
            transition: .3s;

            &:hover,
            &:active,
            &:focus {
              cursor: pointer;
              box-shadow: none;
              border-color: theme(colors.brand.black.500);
            }
          }
        }
      }
    }
  }

  img {
    max-width: 200px;
    padding-top: 3rem;

    @media screen and (min-width: 1200px) {
      max-width: none;
      padding-top: 0;
    }
  }

  > p {
    font-weight: 300;
    margin: 2rem;
    list-style-type: none;
    color: theme(colors.brand.black.500);
  }
}
</style>